// extracted by mini-css-extract-plugin
export default {"product":"productDetail_product__qwbcV"};